import React from 'react';
import { FormattedMessage } from 'react-intl';

import CircularProgress from '@/components/ui-bridge/core/CircularProgress';
import PropTypes from 'prop-types';

import ApiContext from '@/contexts/ApiContext';

function AttachDetailsFooter(props) {
  const buttonBase =
    "inline-flex items-center justify-center rounded border border-transparent px-2 py-[7px] text-[calc(6px+0.4vw)] font-medium text-white transition-colors disabled:opacity-40";

  return (
    <ApiContext.Consumer>
      {apiContext => (
        <div className="mt-2 flex items-center justify-center gap-3">
          <span className="relative inline-block">
            <button
              type="button"
              className={`${buttonBase} w-[9vw] bg-[#A50C00] hover:bg-[#202F4A]`}
              onClick={props.handleCancel}
              disabled={apiContext.status === 'WORKING'}
            >
              <FormattedMessage id="cancel" />
            </button>
          </span>
          <span className="relative inline-block">
            <button
              type="button"
              className={`${buttonBase} w-[9vw] bg-[#909B11] hover:bg-[#202F4A]`}
              onClick={props.handleConfirm}
              disabled={apiContext.status === 'WORKING'}
            >
              <FormattedMessage id="confirm" />
            </button>
            {apiContext.status === 'WORKING' && (
              <CircularProgress
                size={20}
                className="absolute left-1/2 top-1/2 -ml-[10px] -mt-[8px] h-5 w-5"
              />
            )}
          </span>
        </div>
      )}
    </ApiContext.Consumer>
  );
}

AttachDetailsFooter.propTypes = {
  /**
   * Function to confirm the selection
   */
  handleConfirm: PropTypes.func.isRequired,
  /**
   * Function to cancel the selection
   */
  handleCancel: PropTypes.func.isRequired,
};

export default AttachDetailsFooter;
